import { IconActionProfile24 } from '@cian/ui-kit-design-tokens/icons';
import { PictogramPlaceholderImages40 } from '@cian/ui-kit-design-tokens/pictograms';
import * as React from 'react';

import * as styles from './ImageNone.css';

type TImageNoneProps = {
  type: 'offer' | 'agent';
};

export const ImageNone: React.VFC<TImageNoneProps> = ({ type }) => (
  <div className={styles['container']}>
    <span className={styles['icon']}>
      {type === 'offer' ? (
        <PictogramPlaceholderImages40 color="current_color" />
      ) : (
        <IconActionProfile24 color="current_color" />
      )}
    </span>
  </div>
);
